import handicon from './hand.svg';
import fileicon from './files.svg';
import scrollicon from './scroll.svg';
import sendicon from './send.svg';

export const assets = {
    handicon, fileicon, scrollicon, sendicon
}
